module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/postcode.js
// module id = 1431
// module chunks = 1